import angular from 'angular';

angular.module('cloudX').directive('fileUpload', [
  '$timeout',
  function($timeout) {
    return {
      template:
        '<input type="file" style="display: none;" accept="{{allow}}"/>' +
        '<ng-transclude></ng-transclude>',
      transclude: true,
      scope: {
        upload: '&',
        base64: '@',
        allow: '@?',
        singleFile: '@?',
      },
      link: function(scope, element) {
        var fileInput = element.children('input');
        scope.base64 = scope.base64 === 'true';
        fileInput.on('change', function(event) {
          if (!event.target.files) return;
          if (event.target.files.length < 1) return;

          var files = [];

          for (var i = 0; i < event.target.files.length; i++) {
            var file = event.target.files[i];
            if (file === null) return;

            files.push({
              name: file.name,
              data: file,
              size: file.size,
              type: file.type,
            });
          }
          $timeout(function() {
            scope.upload({
              files: files,
            });
          }, 0);

          fileInput[0].value = null;
        });

        //Needed for using this directive on <a> tags
        fileInput.on('click', function(e) {
          e.stopPropagation();
        });

        if (
          typeof scope.singleFile !== 'undefined' &&
          (scope.singleFile === '' || scope.singleFile === 'true')
        ) {
          fileInput.removeAttr('multiple');
        } else {
          fileInput.attr('multiple', 'multiple');
        }

        element.on('click', function(e) {
          fileInput[0].click();
        });
      },
    };
  },
]);
